import React from 'react';
import { HiOutlineX, HiOutlineDownload } from 'react-icons/hi';
import './ImageViewer.css';

const ImageViewer = ({ imageUrl, onClose, title }) => {
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = imageUrl;
        link.download = `delivery-proof-${Date.now()}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="image-viewer-overlay" onClick={onClose}>
            <div className="image-viewer-container" onClick={(e) => e.stopPropagation()}>
                <div className="image-viewer-header">
                    <h3>{title || 'Delivery Proof'}</h3>
                    <div className="image-viewer-actions">
                        <button 
                            className="image-viewer-btn download-btn" 
                            onClick={handleDownload}
                            title="Download"
                        >
                            <HiOutlineDownload size={20} />
                        </button>
                        <button 
                            className="image-viewer-btn close-btn" 
                            onClick={onClose}
                            title="Close"
                        >
                            <HiOutlineX size={24} />
                        </button>
                    </div>
                </div>
                <div className="image-viewer-body">
                    <img src={imageUrl} alt="Delivery Proof" />
                </div>
            </div>
        </div>
    );
};

export default ImageViewer;
